module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iterators.js
// module id = 49
// module chunks = 3